exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".analytics-result {\n  margin-top: 20px;\n}\n\n.analytics-section {\n  margin-bottom: 25px;\n  padding: 15px;\n  background-color: #f9f9f9;\n  border-left: 4px solid #337ab7;\n}\n\n.analytics-section h5 {\n  margin-top: 0;\n  color: #337ab7;\n  font-weight: bold;\n}\n\n.analytics-list {\n  list-style: none;\n  padding-left: 0;\n}\n\n.analytics-list > li {\n  padding: 8px 0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.analytics-list > li:last-child {\n  border-bottom: none;\n}\n\n.percentage {\n  color: #5cb85c;\n  font-weight: bold;\n  margin-left: 5px;\n}\n\n.sub-list {\n  margin-top: 10px;\n  padding-left: 20px;\n  list-style: circle;\n  color: #666;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/export/components/analytics-result/analytics-result.component.css
// module id = ../../../../../src/app/modules/export/components/analytics-result/analytics-result.component.css
// module chunks = main